import {Action} from "redux";
import {
    UpdateClientByClientRequest,
    UpdateCompanyByClientRequest,
    UpdatePasswordByClientRequest,
    UpdateEmailByClientRequest,
} from "../request/mypage_request";
import {
    GetMeClientByClientResponse,
    UpdateCompanyByClientResponse,
    UpdateClientByClientResponse,
    UpdatePasswordByClientResponse,
    UpdateEmailByClientResponse,
} from "../response/mypage_response";


export enum ClientMypageActionType {
    REQUEST_GET_ME_CLIENT = "CLIENT_MYPAGE_REQUEST_GET_ME_CLIENT",
    CALLBACK_GET_ME_CLIENT = "CLIENT_MYPAGE_CALLBACK_GET_ME_CLIENT",

    REQUEST_UPDATE_COMPANY = "CLIENT_MYPAGE_REQUEST_UPDATE_COMPANY",
    CALLBACK_UPDATE_COMPANY = "CLIENT_MYPAGE_CALLBACK_UPDATE_COMPANY",

    REQUEST_UPDATE_CLIENT = "CLIENT_MYPAGE_REQUEST_UPDATE_CLIENT",
    CALLBACK_UPDATE_CLIENT = "CLIENT_MYPAGE_CALLBACK_UPDATE_CLIENT",

    REQUEST_UPDATE_PASSWORD = "CLIENT_MYPAGE_REQUEST_UPDATE_PASSWORD",
    CALLBACK_UPDATE_PASSWORD = "CLIENT_MYPAGE_CALLBACK_UPDATE_PASSWORD",

    REQUEST_UPDATE_EMAIL = "CLIENT_MYPAGE_REQUEST_UPDATE_EMAIL",
    CALLBACK_UPDATE_EMAIL = "CLIENT_MYPAGE_CALLBACK_UPDATE_EMAIL",

}

export interface IRequestGetMeClientAction extends Action {
    type: ClientMypageActionType.REQUEST_GET_ME_CLIENT;
}
export interface ICallbackGetMeClientAction extends Action {
    type: ClientMypageActionType.CALLBACK_GET_ME_CLIENT;
    isSuccess: boolean;
    item?: GetMeClientByClientResponse;
}

export interface IRequestUpdateCompanyAction extends Action {
    type: ClientMypageActionType.REQUEST_UPDATE_COMPANY;
    item: UpdateCompanyByClientRequest;
}
export interface ICallbackUpdateCompanyAction extends Action {
    type: ClientMypageActionType.CALLBACK_UPDATE_COMPANY;
    isSuccess: boolean;
    item?: UpdateCompanyByClientResponse;
}

export interface IRequestUpdateClientAction extends Action {
    type: ClientMypageActionType.REQUEST_UPDATE_CLIENT;
    item: UpdateClientByClientRequest;
}
export interface ICallbackUpdateClientAction extends Action {
    type: ClientMypageActionType.CALLBACK_UPDATE_CLIENT;
    isSuccess: boolean;
    item?: UpdateClientByClientResponse;
}

export interface IRequestUpdatePasswordAction extends Action {
    type: ClientMypageActionType.REQUEST_UPDATE_PASSWORD;
    item: UpdatePasswordByClientRequest;
}
export interface ICallbackUpdatePasswordAction extends Action {
    type: ClientMypageActionType.CALLBACK_UPDATE_PASSWORD;
    isSuccess: boolean;
    item: UpdatePasswordByClientResponse;
}

export interface IRequestUpdateEmailAction extends Action {
    type: ClientMypageActionType.REQUEST_UPDATE_EMAIL;
    item: UpdateEmailByClientRequest;
}
export interface ICallbackUpdateEmailAction extends Action {
    type: ClientMypageActionType.CALLBACK_UPDATE_EMAIL;
    isSuccess: boolean;
    item: UpdateEmailByClientResponse;
}

export type ClientMypageAction =
    IRequestGetMeClientAction |
    ICallbackGetMeClientAction |
    IRequestUpdateCompanyAction |
    ICallbackUpdateCompanyAction |
    IRequestUpdateClientAction |
    ICallbackUpdateClientAction |
    IRequestUpdatePasswordAction |
    ICallbackUpdatePasswordAction |
    IRequestUpdateEmailAction |
    ICallbackUpdateEmailAction;

export interface IClientMypageActionCreator {

    requestGetMeClientAction(): IRequestGetMeClientAction;
    callbackGetMeClientAction(
        isSuccess: boolean,
        item?: GetMeClientByClientResponse,
    ): ICallbackGetMeClientAction;

    requestUpdateCompanyAction(
        item: UpdateCompanyByClientRequest,
    ): IRequestUpdateCompanyAction;
    callbackUpdateCompanyAction(
        isSuccess: boolean,
        item?: UpdateCompanyByClientResponse,
    ): ICallbackUpdateCompanyAction;

    requestUpdateClientAction(
        item: UpdateClientByClientRequest,
    ): IRequestUpdateClientAction;
    callbackUpdateClientAction(
        isSuccess: boolean,
        item?: UpdateClientByClientResponse,
    ): ICallbackUpdateClientAction;

    requestUpdatePasswordAction(
        item: UpdatePasswordByClientRequest,
    ): IRequestUpdatePasswordAction;
    callbackUpdatePasswordAction(
        isSuccess: boolean,
        item?: UpdatePasswordByClientResponse,
    ): ICallbackUpdatePasswordAction;

    requestUpdateEmailAction(
        item: UpdateEmailByClientRequest,
    ): IRequestUpdateEmailAction;
    callbackUpdateEmailAction(
        isSuccess: boolean,
        item?: UpdateEmailByClientResponse,
    ): ICallbackUpdateEmailAction;

}

class ActionCreator implements IClientMypageActionCreator {

    public requestGetMeClientAction = (): IRequestGetMeClientAction => {
        return {
            type: ClientMypageActionType.REQUEST_GET_ME_CLIENT,
        };
    };
    public callbackGetMeClientAction = (
        isSuccess: boolean,
        item?: GetMeClientByClientResponse,
    ): ICallbackGetMeClientAction => {
        return {
            type: ClientMypageActionType.CALLBACK_GET_ME_CLIENT,
            isSuccess,
            item,
        };
    };

    public requestUpdateCompanyAction = (
        item: UpdateCompanyByClientRequest,
    ): IRequestUpdateCompanyAction => {
        return {
            type: ClientMypageActionType.REQUEST_UPDATE_COMPANY,
            item,
        };
    };
    public callbackUpdateCompanyAction = (
        isSuccess: boolean,
        item?: UpdateCompanyByClientResponse,
    ): ICallbackUpdateCompanyAction => {
        return {
            type: ClientMypageActionType.CALLBACK_UPDATE_COMPANY,
            isSuccess,
            item,
        };
    };

    public requestUpdateClientAction = (
        item: UpdateClientByClientRequest,
    ): IRequestUpdateClientAction => {
        return {
            type: ClientMypageActionType.REQUEST_UPDATE_CLIENT,
            item,
        };
    };
    public callbackUpdateClientAction = (
        isSuccess: boolean,
        item?: UpdateClientByClientResponse,
    ): ICallbackUpdateClientAction => {
        return {
            type: ClientMypageActionType.CALLBACK_UPDATE_CLIENT,
            isSuccess,
            item,
        };
    };

    public requestUpdatePasswordAction = (
        item: UpdatePasswordByClientRequest,
    ): IRequestUpdatePasswordAction => {
        return {
            type: ClientMypageActionType.REQUEST_UPDATE_PASSWORD,
            item,
        };
    };
    public callbackUpdatePasswordAction = (
        isSuccess: boolean,
        item: UpdatePasswordByClientResponse,
    ): ICallbackUpdatePasswordAction => {
        return {
            type: ClientMypageActionType.CALLBACK_UPDATE_PASSWORD,
            isSuccess,
            item,
        };
    };

    public requestUpdateEmailAction = (
        item: UpdateEmailByClientRequest,
    ): IRequestUpdateEmailAction => {
        return {
            type: ClientMypageActionType.REQUEST_UPDATE_EMAIL,
            item,
        };
    };
    public callbackUpdateEmailAction = (
        isSuccess: boolean,
        item: UpdateEmailByClientResponse,
    ): ICallbackUpdateEmailAction => {
        return {
            type: ClientMypageActionType.CALLBACK_UPDATE_EMAIL,
            isSuccess,
            item,
        };
    };

}

export const createClientMypageActionCreator = (): IClientMypageActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_mypage_action.ts